// extracted by mini-css-extract-plugin
module.exports = {"dotIndicator":"G0_Zxd","smallIndicator":"FMFp2m","pageIndicator":"Fq5npB","icon":"BpS3a9"};